module.exports = __webpack_public_path__ + "static/media/onlineDelivery.02522825.png";